import dateFnsGenerateConfig from '@rc-component/picker/generate/dateFns';
import { DatePicker as AntdDatePicker } from 'antd';

export const DatePicker = AntdDatePicker.generatePicker(dateFnsGenerateConfig);
